"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _errorActions = require("./errorActions");
var _questionnaireActions = require("../questionnaire/questionnaireActions");
var _recommendationActions = require("../recommendation/recommendationActions");
var _userActions = require("../user/userActions");
var _appActions = require("../appActions");
const initialState = {
  hasError: false,
  errorMessage: '',
  retryIsInProgress: false,
  actionToRetry: {},
  pageToReturnTo: ''
};
const errorReducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let {
    type,
    payload
  } = arguments.length > 1 ? arguments[1] : undefined;
  switch (type) {
    case _errorActions.SET_RETRY_IN_PROGRESS:
      return {
        ...state,
        retryIsInProgress: true
      };
    case _errorActions.API_CALL_ERROR:
      {
        const {
          errorMessage,
          actionToRetry,
          pageToReturnTo
        } = payload;
        return {
          ...state,
          hasError: true,
          errorMessage,
          retryIsInProgress: false,
          actionToRetry,
          pageToReturnTo
        };
      }
    case _questionnaireActions.FETCH_BUDGET_SUCCESS:
    case _userActions.FETCH_USER_SESSION_SUCCESS:
    case _recommendationActions.FETCH_RECOMMENDATION_SUCCESS:
    case _userActions.CREATE_USER_SESSION_SUCCESS:
    case _userActions.SAVE_USER_SESSION_SUCCESS:
    case _appActions.CHECKOUT_SUCCESS:
      return {
        ...state,
        retryIsInProgress: false,
        hasError: false
      };
    case _errorActions.API_CALL_RETRY_SUCCESS:
      return {
        ...state,
        errorMessage: '',
        actionToRetry: {},
        pageToReturnTo: ''
      };
    default:
      return state;
  }
};
var _default = errorReducer;
exports.default = _default;